import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { WebchatConfigService } from '../services/webchat-config.service';

export const pageUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const configSvc = inject(WebchatConfigService);
  const pageUrl = configSvc.hostPageUrl();

  if (pageUrl) {
    return next(req.clone({ setHeaders: { 'X-Page-Url': pageUrl } }));
  }

  return next(req);
};
